import { FC } from 'react'
import {
  Reasoning,
  ReasoningContent,
  ReasoningTrigger,
} from '@/components/ai-elements/reasoning'

/** 思考过程面板(AI Elements Reasoning):流式时 shimmer + 自动展开,结束 1s 后自动收起。 */
export const ReasoningBlock: FC<{ text: string; streaming?: boolean }> = ({
  text,
  streaming = false,
}) => (
  <Reasoning isStreaming={streaming}>
    <ReasoningTrigger />
    <ReasoningContent>{text}</ReasoningContent>
  </Reasoning>
)
